export default {"src":"/_next/static/media/ilu-pledge-bounty.a5539809.svg","height":207,"width":268};